import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaContinue: 'Continue',
    helpText: {
      mandatee:
        'The transfer for the capital deposit must come from a personal bank account of the client.',
      nonMandatee:
        'The transfer for the capital deposit must come from a personal account in your **own name**.',
    },
    noResponse: 'No',
    title: {
      mandatee: 'Does your client have a bank account in France or in Europe?',
      nonMandatee:
        'Do you have a bank account in your name in France or in Europe?',
    },
    yesResponse: 'Yes',
  },
  fr: {
    ctaContinue: 'Continuer',
    helpText: {
      mandatee:
        'Le virement pour le dépôt de capital devra provenir d’un compte bancaire personnel du client.',
      nonMandatee:
        'Le virement pour le dépôt de capital devra provenir d’un compte bancaire à **votre nom propre** (prénom et nom).',
    },
    noResponse: 'Non',
    title: {
      mandatee:
        'Votre client•e possède t•il•elle un compte bancaire en France ou en Europe\u00A0?',
      nonMandatee:
        'Possédez-vous un compte bancaire à votre nom en France ou en Europe\u00A0?',
    },
    yesResponse: 'Oui',
  },
} as const);
